import type * as React from "react";
import { useHistory } from "react-router-dom";
import { Grid, Typography, Modal } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";

import GLButton from "../../GLButton";
import { PATHS } from "../../../../../constants/pathConstants";
import { COLORS } from "components/v3/Theme/colors";

interface AgreementsUpdatedModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AgreementsUpdatedModal: React.FC<AgreementsUpdatedModalProps> = ({
  isOpen,
  onClose
}) => {
  const history = useHistory();

  const handleContinue = () => {
    onClose();
    history.push(PATHS.ACCOUNT_MANAGEMENT_UPDATE_AGREEMENTS);
  };

  return (
    <Modal
      open={isOpen}
      disableAutoFocus={true}
      disableEscapeKeyDown={true}
      className="agreements-updated-modal"
      sx={{
        outline: "0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "auto",
        "& .MuiModal-backdrop": {
          backgroundColor: `${COLORS.PRIMARY_DARKER}80`
        }
      }}
    >
      <Grid
        item
        xs={11}
        sm={8}
        md={6}
        lg={4}
        sx={{
          borderRadius: "16px",
          padding: 3,
          backgroundColor: COLORS.WHITE,
          boxShadow: 5,
          maxHeight: "95vh",
          overflowY: "auto",
          position: "relative",
          maxWidth: "600px",
          width: "100%",
          margin: "15px"
        }}
      >
        <Grid item xs={12} pt={3} pb={3}>
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            sx={{
              textAlign: "center",
              "& p": { marginBottom: "15px" },
              "& h4": { marginBottom: "20px" }
            }}
          >
            <Grid item xs={12}>
              <Typography>
                <strong>User agreements updated</strong>
              </Typography>
            </Grid>
            <Grid item xs={9} mb={3}>
              <Typography>
                Please review and accept these updated
                <br />
                legal documents before proceeding
              </Typography>
            </Grid>
            <GLButton
              buttonType="primary"
              onClick={handleContinue}
              rightIcon={<ArrowForward />}
            >
              Continue
            </GLButton>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default AgreementsUpdatedModal;
